import { useFadeIn } from '../../../hooks/useFadeIn';

export default function CTA() {
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  return (
    <section id="cta-section" className="relative min-h-[60vh] py-16 overflow-hidden flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/assets/senteo-corp/img/service/cta.jpg"
          alt="背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#1A3B5C]/70"></div>
      </div>

      <div 
        ref={ref}
        className={`relative max-w-7xl mx-auto px-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="flex flex-col items-center justify-center text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            まずはお気軽に<br />ご相談ください
          </h2>
          <p className="text-lg text-white/90 leading-relaxed mb-8">
            ご質問・ご相談は下記フォームにて承ります。<br />
            貴社の課題に合わせた最適なプランをご提案いたします。
          </p>
          <a 
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=YKcf0P9g2U-Our9eD2Xtbv5ca4bq0tFEuCs_nTfkrFhUN0Y5NDJKVjZYM0tWSU5CMVU3TkZWTEM3VS4u"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#FF6B6B] text-white text-lg font-bold rounded-full hover:bg-[#FF5252] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>無料でご相談</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
